"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiPaymentAccountFindQueryDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
class BillingApiPaymentAccountFindQueryDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента для фильтрации по нему",
  format: "uuid",
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentAccountFindQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id начисления для поиска счетов подходящих для оплаты указанного начисления",
  format: "uuid",
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentAccountFindQueryDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id провайдера для фильтрации по нему",
  format: "uuid",
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiPaymentAccountFindQueryDto.prototype, "providerId", void 0);
exports.BillingApiPaymentAccountFindQueryDto = BillingApiPaymentAccountFindQueryDto;
